import { schema } from 'normalizr';
import { IFranfinanceEntities } from 'services/ApiService';

const createNormalizrPayload = (entitySchema: schema.Entity, entityIds: (string | number)[]) => {
    return {
        [entitySchema.key]: entityIds ? entityIds.reduce((prev, id) => {
            prev[id] = null;
            return prev;
        }, {} as { [id: string]: null; }) : null,
    };
};

const mergeEntities = <T, TU extends string>(type: TU) => (payload: T) => {
    return {
        type,
        payload,
    } as const;
};

const removeEntities = <TU extends string>(type: TU) => (entitySchema: schema.Entity, entityIds: Array<string | number>) => {
    const payload = createNormalizrPayload(entitySchema, entityIds);
    return {
        type,
        payload,
    } as const;
};

export const mergeFranfinanceEntities = mergeEntities<IFranfinanceEntities, '@NORMALIZR/MERGE_FRANFINANCE_ENTITIES'>('@NORMALIZR/MERGE_FRANFINANCE_ENTITIES');
export const removeFranfinanceEntities = removeEntities<'@NORMALIZR/REMOVE_FRANFINANCE_ENTITIES'>('@NORMALIZR/REMOVE_FRANFINANCE_ENTITIES');

export type NormalizrAction =
    | ReturnType<typeof mergeFranfinanceEntities>
    | ReturnType<typeof removeFranfinanceEntities>;
